import React from 'react';
import GraphicContentEditor, { GraphicContentEditorProps } from './graphic-content-editor';
import _has from 'lodash/has';
import * as Graphic from '@src/slide/infrastructure/module/independent/graphic';

const WRAPPER_LENGTH = 48;
const CONTAINER_LENGTH = 16;
const BORDER_LENGTH = 14;
const INNER_LENGTH = 10;

interface GraphicContentEditorMobileProps extends GraphicContentEditorProps {
    isDragging?: boolean;
    isResizing?: boolean;
    isRotating?: boolean;
    editorIsEditing?: boolean;
    isMobileRotatingMode?: boolean;
    onControlValueChange?: (controlValues: any) => void;
    onControlPointMouseDown?: () => void;
}

interface GraphicContentEditorMobileState {
    startPos: { x: number; y: number; };
    changeControlPointIndex: number;
    leftInClient: number;
    topInClient: number;
}

export default class GraphicContentEditorMobile
    extends GraphicContentEditor<GraphicContentEditorMobileProps, GraphicContentEditorMobileState> {
    public componentDidMount() {
        window.addEventListener('enterEditing', this.updateComponent);
        window.addEventListener('exitEditing', this.updateComponent);
    }

    public componentWillUnmount() {
        window.removeEventListener('enterEditing', this.updateComponent);
        window.removeEventListener('exitEditing', this.updateComponent);
    }

    public render() {
        if (this.props.isDragging
            || this.props.isResizing
            || this.props.isRotating
            || this.props.editorIsEditing
            || this.props.isMobileRotatingMode) return null;

        return (
            <React.Fragment>
                {
                    this.renderControlPoints()
                }
            </React.Fragment>
        );
    }
    protected renderControlPoint = (point: { x: number; y: number; }, index: number) => {
        const diameter = WRAPPER_LENGTH;
        const innerDiameter = CONTAINER_LENGTH;
        const innerDiameterBack = BORDER_LENGTH;
        const innerInnerDiameter = INNER_LENGTH;
        return (
            <div
                key={index}
                onMouseDown={this.handleControlPointMouseDown.bind(this, index)}
                onTouchStart={this.handleControlPointMouseDown.bind(this, index)}
                style={{
                    width: diameter,
                    height: diameter,
                    left: (point.x * this.props.scale) - (diameter / 2),
                    top: (point.y * this.props.scale) - (diameter / 2),
                    position: 'absolute',
                    zIndex: 1000,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    pointerEvents: 'auto',
                }}
            >
                <div
                    style={{
                        width: innerDiameter,
                        height: innerDiameter,
                        border: `${1}px solid rgba(0, 0, 0, 0.12)`,
                        borderRadius: '50%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <div style={{
                        width: innerDiameterBack,
                        height: innerDiameterBack,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'white',
                        borderRadius: '50%',
                    }}>
                        <div
                            style={{
                                width: innerInnerDiameter,
                                height: innerInnerDiameter,
                                borderRadius: '50%',
                                backgroundColor: '#FFAB00',
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    };

    protected handleControlPointMouseDown = (index: number, e: React.MouseEvent | React.TouchEvent) => {
        e.stopPropagation();
        e.preventDefault();
        this.startPos = this.getRelativePosByEvent(e);
        this.changeControlPointIndex = index;
        let controlPoint = { x: this.controlPoints[index].x, y: this.controlPoints[index].y };
        if (_has(this.props.model, 'rotate') && this.props.model.rotate) {
            const { rotate, width, height } = this.props.model;
            controlPoint = Graphic.afterRotate(controlPoint, rotate, width / 2, height / 2);
        }
        this.leftInClient = this.startPos.x - controlPoint.x;
        this.topInClient = this.startPos.y - controlPoint.y;
        document.body.addEventListener('mousemove', this.handleControlPointMouseMove);
        document.body.addEventListener('mouseup', this.handleControlPointChangeEnd);
        document.body.addEventListener('touchmove', this.handleControlPointMouseMove, { passive: false });
        document.body.addEventListener('touchend', this.handleControlPointChangeEnd);
        if (this.props.onControlPointMouseDown) {
            this.props.onControlPointMouseDown();
        }
    };

    protected handleControlPointChangeEnd = (e: MouseEvent | TouchEvent) => {
        e.stopPropagation();
        e.preventDefault();
        document.body.removeEventListener('mousemove', this.handleControlPointMouseMove);
        document.body.removeEventListener('mouseup', this.handleControlPointChangeEnd);
        document.body.removeEventListener('touchmove', this.handleControlPointMouseMove);
        document.body.removeEventListener('touchend', this.handleControlPointChangeEnd);
        if (this.props.onControlValueChange) {
            this.props.onControlValueChange(this.pathParser.controlValues);
        }
    };

    private updateComponent = () => {
        this.forceUpdate();
    };
}
